export const DRAWER_WIDTH_CHANGE_PLACEMENT = 992;
export const WIDTH_VIEW_LIST_COMPONENT_ACTIONS = 992;
export const LOGIN_WIDTH_CHANGE_PLACEMENT = 992;

export const MODAL_WIDTH_LEVEL_1 = '90%';
export const MODAL_TOP_LEVEL_1 = '15%';
export const MODAL_HEIGHT_LEVEL_1 = '50vh';

export const MODAL_WIDTH_LEVEL_2 = '85%';
export const MODAL_TOP_LEVEL_2 = '20%';
export const MODAL_HEIGHT_LEVEL_2 = '50vh';

export const MODAL_WIDTH_LEVEL_3 = '80%';
export const MODAL_TOP_LEVEL_3 = '25%';
export const MODAL_HEIGHT_LEVEL_3 = '50vh';

export const MODAL_WIDTH_LEVEL_4 = '75%';
export const MODAL_TOP_LEVEL_4 = '30%';
export const MODAL_HEIGHT_LEVEL_4 = '45vh';